<template>
  <v-simple-table
    fixed-header
    max-height="600px"
    class="ml-10 mr-10 mt-10 mb-3"
  >
    <template v-slot:default>
      <thead>
        <tr>
          <th></th>
          <th v-for="plan in plans" :key="plan.Name">{{ plan.Name }}</th>
        </tr>
      </thead>
      <tbody style="pointer-events: none;">
        <tr v-for="tableRow in tableRows" v-bind:key="tableRow.key">
          <template>
            <td style="font-size: 18px;">{{ tableRow.name }}</td>
            <td v-for="plan in plans" :key="plan.Name" style="font-size: 15px;">
              <span v-if="tableRow.isBool">
                <v-icon v-if="plan[tableRow.key]" color="danger">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
                <v-icon v-else color="danger">
                  mdi-close
                </v-icon>
              </span>
              <span v-else>
                {{ plan[tableRow.key] }}
              </span>
            </td>
          </template>
        </tr>
      </tbody>
      <tfoot v-if="myPlan">
        <tr v-if="myPlan.CreditCardReady && !loadingChangePlan">
          <td></td>
          <td v-for="plan in plans" :key="plan.Name">
            <v-btn
              disabled
              v-if="
                (plan.Name == 'Free' && !myPlan.CurrentPlan) ||
                  plan.Name == myPlan.CurrentPlan ||
                  myPlan.PaymentStatus === 'failure' ||
                  !is_empty(team.TeamId)
              "
            >
              choose
            </v-btn>
            <v-btn
              v-else
              color="primary"
              style="pointer-events: fill;"
              @click="$emit('choose', plan.Name)"
            >
              choose
            </v-btn>
          </td>
        </tr>
        <tr v-else-if="loadingChangePlan">
          <td></td>
          <td v-for="(_, name) in plansForView" v-bind:key="name"></td>
        </tr>
        <tr v-else>
          <td :colspan="Object.keys(plansForView).length + 1">
            <p class="red--text text--darken-2">
              To change subscription plan, you must register your credit card
              information.
            </p>
            <p>
              If you want to use payment methods other than the credit card,
              <br />
              please contact:
              <a href="mailto:support@cubic-cloud.com">
                support@cubic-cloud.com
              </a>
              with the subject line “subscription request”.
            </p>
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'PlansTable',
  props: {
    loadingChangePlan: {
      type: Boolean,
      default: false,
    },
    myPlan: {
      type: Object,
      default: null,
    },
    plans: {
      type: Array,
      required: true,
    },
    team: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      plansForView: {},
      functions: [],
      tableRows: [
        {
          key: 'Price',
          name: 'Price($ per month)',
          isBool: false,
        },
        {
          key: 'UploadQuota',
          name: 'Brain uploads per month',
          isBool: false,
        },
        {
          key: 'NotebooksQuota',
          name: 'Notebook jobs per month',
          isBool: false,
        },
        {
          key: 'Share',
          name: 'Share data',
          isBool: true,
        },
        {
          key: 'ViewShared',
          name: 'View shared data',
          isBool: true,
        },
        {
          key: 'Publish',
          name: 'Publish data',
          isBool: true,
        },
        {
          key: 'ViewPublished',
          name: 'View published data',
          isBool: true,
        },
        {
          key: 'DownloadRaw',
          name: 'Downloading raw brain data',
          isBool: true,
        },
        {
          key: 'Team',
          name: 'Team',
          isBool: true,
        },
        {
          key: 'Import',
          name: 'Import',
          isBool: true,
        },
      ],
    }
  },
}
</script>

<style scoped>
.v-data-table__wrapper th {
  font-size: 18px;
  text-align: center;
  color: #00bfff !important;
}
.v-data-table__wrapper td {
  text-align: center;
}
</style>
